export const THREE_YEARS = 1800000;
export const TIME = Date.now();
export const DEVICE = 'pc';
